import { getMediaFiles, getGalleryAlbums, getAlbumPhotos } from '../lib/data.js';
import { mediaUrl } from '../lib/supabase.js';
import { esc } from '../lib/utils.js';

export async function renderMedia(view) {
    const [media, albums] = await Promise.all([getMediaFiles(), getGalleryAlbums()]);

    view.innerHTML = `
        <section class="section narrow">
            <h1 class="page-title">Média</h1>
            <div class="media-tabs">
                <button class="media-tab" data-tab="galerie">Fotogalerie</button>
                <button class="media-tab" data-tab="hudba">Hudba</button>
            </div>
        </section>

        <section class="section" id="tab-galerie">
            <div id="gallery-host"></div>
        </section>

        <section class="section" id="tab-hudba" hidden>
            ${media.length ? `
                <div class="media-list">
                    ${media.map((m) => mediaItem(m)).join('')}
                </div>`
            : '<p class="empty">Hudba a videa se brzy doplní.</p>'}
        </section>
    `;

    const tabs = [...view.querySelectorAll('.media-tab')];
    const panelGalerie = view.querySelector('#tab-galerie');
    const panelHudba = view.querySelector('#tab-hudba');
    function showTab(name) {
        tabs.forEach((t) => t.classList.toggle('active', t.dataset.tab === name));
        panelGalerie.hidden = name !== 'galerie';
        panelHudba.hidden = name !== 'hudba';
    }
    tabs.forEach((t) => t.addEventListener('click', () => {
        showTab(t.dataset.tab);
        // Klik na Fotogalerii vždy vrátí na seznam alb — i když jsi uvnitř alba.
        if (t.dataset.tab === 'galerie') {
            renderAlbumList(view.querySelector('#gallery-host'), albums);
        }
    }));
    showTab('galerie');

    wireSinglePlayback(view);
    renderAlbumList(view.querySelector('#gallery-host'), albums);
}

// --- Hudba a videa ---------------------------------------------------------
function mediaItem(m) {
    const url = mediaUrl(m.path);
    if (m.kind === 'video') {
        return `
        <div class="media-item media-video-item">
            <strong class="media-name">${esc(m.label)}</strong>
            <video controls preload="metadata" src="${esc(url)}"></video>
        </div>`;
    }
    return `
        <div class="media-item media-audio-item">
            <strong class="media-name">${esc(m.label)}</strong>
            <audio controls preload="none" src="${esc(url)}"></audio>
        </div>`;
}

// Hraje vždy jen jeden soubor — spuštění jednoho zastaví ostatní.
function wireSinglePlayback(view) {
    const players = [...view.querySelectorAll('audio, video')];
    players.forEach((p) => {
        p.addEventListener('play', () => {
            players.forEach((o) => { if (o !== p && !o.paused) o.pause(); });
        });
    });
}

// --- Fotogalerie: přehled alb ----------------------------------------------
function renderAlbumList(host, albums) {
    if (!albums.length) {
        host.innerHTML = '<p class="empty">Fotky se brzy doplní.</p>';
        return;
    }
    host.innerHTML = `
        <div class="album-grid">
            ${albums.map((a) => {
                const cover = a.cover ? mediaUrl(a.cover) : '';
                return `
                    <button class="album-tile ${cover ? '' : 'no-cover'}" data-album="${esc(a.key)}"
                        ${cover ? `style="background-image:url('${esc(cover)}')"` : ''}>
                        <span class="album-tile-label">
                            <strong>${esc(a.name)}</strong>
                            <span>${a.count} ${fotoWord(a.count)}</span>
                        </span>
                    </button>`;
            }).join('')}
        </div>`;
    host.querySelectorAll('.album-tile').forEach((tile) => {
        tile.addEventListener('click', () => openAlbum(host, tile.dataset.album, albums));
    });
}

async function openAlbum(host, albumKey, albums) {
    host.innerHTML = '<p class="muted">Načítám fotky…</p>';
    const album = albums.find((a) => a.key === albumKey);
    const title = album ? album.name : albumKey;
    const photos = await getAlbumPhotos(albumKey);
    host.innerHTML = `
        <button class="back-link" id="gallery-back">← Zpět na alba</button>
        <h3 class="album-title">${esc(title)}</h3>
        ${photos.length ? `
            <div class="gallery-grid">
                ${photos.map((p, i) => `
                    <button class="gallery-item" data-index="${i}" aria-label="Fotka ${i + 1}">
                        <img src="${esc(mediaUrl(p))}" loading="lazy" decoding="async" alt="">
                    </button>`).join('')}
            </div>`
        : '<p class="empty">V tomto albu zatím nejsou žádné fotky.</p>'}
    `;
    host.querySelector('#gallery-back').addEventListener('click', () => renderAlbumList(host, albums));
    host.querySelectorAll('.gallery-item').forEach((btn) => {
        btn.addEventListener('click', () => openLightbox(photos, Number(btn.dataset.index)));
    });
}

function fotoWord(n) {
    if (n === 1) return 'fotka';
    if (n >= 2 && n <= 4) return 'fotky';
    return 'fotek';
}

// --- Lightbox --------------------------------------------------------------
const MAX_ICON = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none"
    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>`;

function openLightbox(photos, startIndex) {
    let index = startIndex;
    let tiltDeg = 0;
    const box = document.createElement('div');
    box.className = 'lightbox';

    function paint() {
        box.innerHTML = `
            <button class="lb-close" aria-label="Zavřít">✕</button>
            <button class="lb-max" aria-label="Na celou obrazovku">${MAX_ICON}</button>
            <button class="lb-prev" aria-label="Předchozí">‹</button>
            <figure class="lb-figure">
                <img src="${esc(mediaUrl(photos[index]))}" alt="Fotka ${index + 1}">
            </figure>
            <button class="lb-next" aria-label="Další">›</button>`;
        box.querySelector('.lb-close').onclick = close;
        box.querySelector('.lb-max').onclick = toggleFull;
        box.querySelector('.lb-prev').onclick = () => { index = (index - 1 + photos.length) % photos.length; paint(); };
        box.querySelector('.lb-next').onclick = () => { index = (index + 1) % photos.length; paint(); };
        applyTilt();
    }

    // --- Maximalizace na celou obrazovku ---
    function fsElement() {
        return document.fullscreenElement || document.webkitFullscreenElement;
    }
    function toggleFull() {
        if (fsElement()) {
            (document.exitFullscreen || document.webkitExitFullscreen).call(document);
            return;
        }
        const req = box.requestFullscreen || box.webkitRequestFullscreen;
        if (req) {
            req.call(box);
        } else {
            // iPhone Safari neumí fullscreen pro <div> — overlay už kryje celou obrazovku.
            box.classList.toggle('lb-fill');
        }
        requestTilt();
    }

    // --- Otáčení fotky podle náklonu telefonu (funguje i při zamčené orientaci) ---
    function onTilt(e) {
        const g = e.gamma || 0, b = e.beta || 0;
        let deg = 0;
        if (Math.abs(g) > 35 && Math.abs(b) < 55) deg = g > 0 ? 90 : -90;
        if (deg !== tiltDeg) { tiltDeg = deg; applyTilt(); }
    }
    function applyTilt() {
        // Pokud se rozvržení už samo otočilo (orientace odemčená), neotáčíme znovu.
        const layoutLandscape = window.matchMedia('(orientation: landscape)').matches;
        const deg = layoutLandscape ? 0 : tiltDeg;
        const img = box.querySelector('.lb-figure img');
        if (img) img.style.transform = deg ? `rotate(${deg}deg)` : '';
        box.classList.toggle('lb-rotated', deg !== 0);
    }
    function requestTilt() {
        const D = window.DeviceOrientationEvent;
        if (!D) return;
        if (typeof D.requestPermission === 'function') {
            D.requestPermission()
                .then((r) => { if (r === 'granted') window.addEventListener('deviceorientation', onTilt); })
                .catch(() => {});
        } else {
            window.addEventListener('deviceorientation', onTilt);
        }
    }

    function close() {
        if (fsElement()) (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        window.removeEventListener('deviceorientation', onTilt);
        window.removeEventListener('resize', applyTilt);
        box.remove();
        document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') { index = (index - 1 + photos.length) % photos.length; paint(); }
        if (e.key === 'ArrowRight') { index = (index + 1) % photos.length; paint(); }
    }

    box.addEventListener('click', (e) => { if (e.target === box) close(); });
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', applyTilt);
    paint();
    document.body.appendChild(box);
}
